export function decodeHtmlText(value=''){
  if(!value||typeof document==='undefined')return value;
  const element=document.createElement('textarea');
  element.innerHTML=value;
  return element.value.replace(/\s+/g,' ').trim();
}
